import { render, staticRenderFns } from "./PreviewLink.vue?vue&type=template&id=253f8ab1"
import script from "./PreviewLink.vue?vue&type=script&lang=js"
export * from "./PreviewLink.vue?vue&type=script&lang=js"
import style0 from "./PreviewLink.vue?vue&type=style&index=0&id=253f8ab1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports